module.exports = __webpack_public_path__ + "img/download_icon.24b9f0ed.svg";